// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M22 8H14V6H10C8.34315 6 7 7.34315 7 9H10V15H7C7 16.6569 8.34315 18 10 18H14V16H22V22H14V20H10C7.23858 20 5 17.7614 5 15H2V9H5C5 6.23858 7.23858 4 10 4H14V2H22V8Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-mind-map-filled')
export default class MindMapFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'mind-map-filled',
    }
  }
}
